<template>
    <div class="col page-element">
        <alert-loading v-if="loading"></alert-loading>
        <page-title v-if="!loading"><h3>Lista umów</h3>
            <div class="page-title__buttons">
                <router-link :to="{name: 'AgreementCreate', query: { customer: id }}" title="Dodaj umowę" class="btn btn-default"><span>Dodaj umowę</span><svg-icon name="plus"/></router-link>
            </div>
        </page-title>

        <div v-if="!loading" class="table-responsive">
            <table class="table table-striped table-bordered table-hover table-clickable table-search">
            <thead>
                <tr>
                    <th>Numer</th>
                    <th>Data zawarcia</th>
                    <th>Do zapłaty</th>
                    <th>Waluta</th>
                    <th>Status</th>
                    <th>Faktura</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in items">
                    <td><router-link v-if="item" :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item['fullNumber'] }}</router-link></td>
                    <td><router-link v-if="item" :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item['date'] | date }}</router-link></td>
                    <td><router-link v-if="item" :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item['leftToPaid'] }}</router-link></td>
                    <td><router-link v-if="item" :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item.currency.name }}</router-link></td>
                    <td><router-link v-if="item" :to="{name: 'AgreementShow', params: { id: item['id'] }}"><span class="element_status" :class="item.status">{{ item['status'] | translate }}</span></router-link></td>
                    <td><router-link v-if="item" :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item['invoiceData'] }}</router-link></td>
                    <td>
                        <router-link :to="{name: 'AgreementUpdate', params: { id: item['id'] }}" v-b-tooltip.hover.bottom title="Edytuj" class="btn btn-icon">
                            <svg-icon name="edit"/>
                        </router-link>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

	export default {
        computed: mapGetters({
            error: 'customer/agreementList/error',
            loading: 'customer/agreementList/loading',
            items: 'customer/agreementList/items',
        }),
		props: {
			id: {
				type: String,
                default: '',
                required: true
			}
        },
        created () {
            this.$store.dispatch('customer/agreementList/getItems', this.id)
        }
	}
</script>


// WEBPACK FOOTER //
// AgreementList.vue?4fe86dfc